import { render, staticRenderFns } from "./popAnchor.vue?vue&type=template&id=56789c0a&scoped=true"
import script from "./popAnchor.vue?vue&type=script&lang=js"
export * from "./popAnchor.vue?vue&type=script&lang=js"
import style0 from "./popAnchor.vue?vue&type=style&index=0&id=56789c0a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_71321242e37ff7a0c7584d931db29eba/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56789c0a",
  null
  
)

export default component.exports